// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__RwN2u","sendOtp":"AuthorizeToLogin_sendOtp__1zExc"};